import { render, staticRenderFns } from "./buscaCepEndereco.vue?vue&type=template&id=768b2a0a"
import script from "./buscaCepEndereco.vue?vue&type=script&lang=js"
export * from "./buscaCepEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports